import React from "react";
import { Menu, Dropdown, Badge } from "antd";
import "./style.scss";

class NotificationMenu extends React.Component {
  render() {
    const menu = (
      <Menu selectable={false} className="topbar__activity notifications">
        <Menu.Item disabled>
          <div className="topbar__activity__item">
            <i className="topbar__activity__icon fa fa-inbox utils__spin-delayed--pseudo-selector" />
            <div className="topbar__activity__inner">
              <div className="topbar__activity__title">No notifications</div>
            </div>
          </div>
        </Menu.Item>
      </Menu>
    );
    return (
      <div className="topbar__dropdown d-inline-block">
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <a className="ant-dropdown-link" href="/">
            <i className="icon icon-notification" />
          </a>
        </Dropdown>
      </div>
    );
  }
}

export default NotificationMenu;

/*

            <Badge dot={true}>
              <i className="icon icon-notification" />
            </Badge>
<Menu.Item>
          <div className="topbar__activity__item">
            <i className="topbar__activity__icon icon-settings utils__spin-delayed--pseudo-selector" />
            <div className="topbar__activity__inner">
              <div className="topbar__activity__title">
                <span className="pull-right">now</span>
                <a href="javascript: void(0);">
                  Flow Updated <span className="badge badge-danger">New</span>
                </a>
              </div>
              <div className="topbar__activity__descr">
                Your Flow has been updated
              </div>
            </div>
          </div>
        </Menu.Item>

        <Menu.Item>
          <div className="topbar__activity__item">
            <i className="topbar__activity__icon icon-inbox" />
            <div className="topbar__activity__inner">
              <div className="topbar__activity__title">
                <span className="pull-right">30 min ago</span>
                <a href="javascript: void(0);">Inbox Message</a>
              </div>
              <div className="topbar__activity__descr">
                From: <a href="javascript: void(0);">Charles Conell</a>
              </div>
            </div>
          </div>
        </Menu.Item>

        <Menu.Item>
          <div className="topbar__activity__item">
            <i className="topbar__activity__icon icon-inbox" />
            <div className="topbar__activity__inner">
              <div className="topbar__activity__title">
                <span className="pull-right">10 min ago</span>
                <a href="javascript: void(0);">
                  Inbox Message <span className="badge badge-success">New</span>
                </a>
              </div>
              <div className="topbar__activity__descr">
                From: <a href="javascript: void(0);">Rachel Vickery</a>
              </div>
            </div>
          </div>
        </Menu.Item>*/



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/TopBar/NotificationMenu/index.js